'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _fetchError = require('../../util/fetch-error');

var _fetchError2 = _interopRequireDefault(_fetchError);

var _estimatedDelivery = require('../../globals/estimated-delivery');

var _estimatedDelivery2 = _interopRequireDefault(_estimatedDelivery);

var _getDevice = require('../../util/get-device');

var _getDevice2 = _interopRequireDefault(_getDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default); /* eslint-env browser */

exports.default = new _vuex2.default.Store({
  state: {
    settings: {
      moneyFormat: window.theme.moneyFormat ? window.theme.moneyFormat : '€{{amount_with_comma_separator}}'
    },
    common: {
      backdropVisible: false,
      backdropType: '',
      modalBackInStock: false,
      productIndex: {},
      productReferenceToHandle: {},
      allProductsLoadedPage: 0,
      allProductsLoaded: false,
      menuDrawerVisible: false
    },
    notification: {
      link: {
        href: '',
        text: ''
      },
      message: '',
      type: 'success',
      autoDestroy: true
    },
    modal: {
      content: '',
      type: ''
    },
    product: {
      visibleProduct: {},
      variantId: null,
      bottomLine: {},
      yotpoImages: {}
    },
    packs: {
      packProducts: [],
      packCount: 0,
      packType: '',
      packconfig: {}
    },
    familyPack: {
      configuratorOpen: false,
      packProducts: [],
      packState: {},
      packConfig: {}
    },
    collection: {
      initialFilters: {},
      selectedFilters: {},
      filters: {},
      filtersOrder: {},
      loadedProductImages: []
    },
    search: {
      searchInitialFilters: {},
      searchFiltersOrder: {},
      searchProducts: [],
      searchFilters: {},
      searchSelectedFilters: {}
    },
    cookiesBanner: {
      bannerVisible: false
    },
    cart: {
      content: {},
      extraProductInfo: {},
      cartLoaded: false,
      drawerVisible: false,
      cantEstimateShipping: false,
      deliveryEstimates: [],
      estimateAddress: null,
      totals: {
        shipping: 0,
        discounts: 0
      },
      busy: false,
      shipRatesPrepared: false,
      shipRatesChecked: false,
      checkRatesMadeTries: 0,
      checkRatesMaxTries: 10,
      checkingShippingRates: false,
      estimatedDelivery: new _estimatedDelivery2.default(),
      autoCloseDrawer: false,
      giftNoteVariantId: null,
      giftNote: {
        to: '',
        from: '',
        message: '',
        editMode: true,
        hasNote: false
      },
      discountsLoaded: false,
      discountsApplying: false,
      discounts: {}
    },
    quickview: {
      open: false,
      visibleProduct: {}
    },
    analytics: {
      impresionsQueuedInitiated: false,
      impresionsProcessed: [],
      impresionsQueued: []
    }
  },

  getters: {
    test: function test(state) {
      return state.notification.type;
    }
  },

  mutations: {
    toggleQuickview: function toggleQuickview(state) {
      state.quickview.open = !state.quickview.open;
    },
    setQuickviewProduct: function setQuickviewProduct(state, product) {
      state.quickview.visibleProduct = product;
    },
    impressionQueueInit: function impressionQueueInit(state) {
      state.analytics.impresionsQueuedInitiated = true;
    },
    addImpresion: function addImpresion(state, product) {
      state.analytics.impresionsProcessed.push(product.handle);
      state.analytics.impresionsQueued.push(product);
    },
    clearImpresionQueue: function clearImpresionQueue(state) {
      state.analytics.impresionsQueued = [];
    },
    setModal: function setModal(state, modal) {
      state.modal = modal;
    },
    openModalBackInStock: function openModalBackInStock(state, visible) {
      state.common.modalBackInStock = visible;
    },
    setVariantId: function setVariantId(state, variantId) {
      state.product.variantId = variantId;
    },
    setBottomLine: function setBottomLine(state, bottomLine) {
      state.product.bottomLine = bottomLine;
    },
    setYotpoImages: function setYotpoImages(state, yotpoImages) {
      state.product.yotpoImages = yotpoImages;
    },
    changeFilters: function changeFilters(state, filters) {
      state.collection.filters = filters;
    },
    changeInitialFilters: function changeInitialFilters(state, initialFilters) {
      state.collection.initialFilters = initialFilters;
    },
    changeFiltersOrder: function changeFiltersOrder(state, filtersOrder) {
      state.collection.filtersOrder = filtersOrder;
    },
    changeSelectedFilters: function changeSelectedFilters(state, selectedFilters) {
      state.collection.selectedFilters = selectedFilters;
    },
    changeSearchProducts: function changeSearchProducts(state, searchProducts) {
      state.search.searchProducts = searchProducts;
    },
    changeSearchInitialFilters: function changeSearchInitialFilters(state, searchInitialFilters) {
      state.search.searchInitialFilters = searchInitialFilters;
    },
    changeSearchFiltersOrder: function changeSearchFiltersOrder(state, searchFiltersOrder) {
      state.collection.searchFiltersOrder = searchFiltersOrder;
    },
    changeSearchFilters: function changeSearchFilters(state, searchFilters) {
      state.search.searchFilters = searchFilters;
    },
    changeSearchSelectedFilters: function changeSearchSelectedFilters(state, searchSelectedFilters) {
      state.search.searchSelectedFilters = searchSelectedFilters;
    },
    changePackProducts: function changePackProducts(state, packProducts) {
      state.packs.packProducts = packProducts;
    },
    changePackCount: function changePackCount(state, packCount) {
      state.packs.packCount = packCount;
    },
    changePackType: function changePackType(state, packType) {
      state.packs.packType = packType;
    },
    changePackConfig: function changePackConfig(state, packConfig) {
      state.packs.packConfig = packConfig;
    },
    setFamilyPackConfiguratorOpen: function setFamilyPackConfiguratorOpen(state, configuratorOpen) {
      state.familyPack.configuratorOpen = configuratorOpen;
    },
    changeFamilyPackProducts: function changeFamilyPackProducts(state, packProducts) {
      state.familyPack.packProducts = packProducts;
    },
    familyPackAddAdult: function familyPackAddAdult(state, product) {
      _vue2.default.set(state.familyPack.packProducts, 1, product);
    },
    familyPackAddKids: function familyPackAddKids(state, product) {
      _vue2.default.set(state.familyPack.packProducts, 2, product);
    },
    familyPackAddItem: function familyPackAddItem(state, product) {
      state.familyPack.packProducts.push(product);
    },
    familyPackRemoveAdult: function familyPackRemoveAdult(state) {
      _vue2.default.set(state.familyPack.packProducts, 1, {});
    },
    familyPackRemoveKids: function familyPackRemoveKids(state) {
      _vue2.default.set(state.familyPack.packProducts, 2, {});
    },
    familyPackRemoveItem: function familyPackRemoveItem(state, index) {
      state.familyPack.packProducts.splice(index, 1);
    },
    setFamilyPackState: function setFamilyPackState(state, packState) {
      state.familyPack.packState = packState;
    },
    changeFamilyPackConfig: function changeFamilyPackConfig(state, packConfig) {
      state.familyPack.packConfig = packConfig;
    },
    changeCart: function changeCart(state, cart) {
      state.cart.content = cart;
    },
    changeEstimates: function changeEstimates(state, deliveryEstimates) {
      state.cart.deliveryEstimates = deliveryEstimates;
    },
    setEstimateAddress: function setEstimateAddress(state, estimateAddress) {
      state.cart.estimateAddress = estimateAddress;
    },
    setCartLoaded: function setCartLoaded(state) {
      state.cart.cartLoaded = true;
    },
    setShipRatesPrepared: function setShipRatesPrepared(state) {
      state.cart.shipRatesPrepared = true;
    },
    setShipRatesChecked: function setShipRatesChecked(state) {
      state.cart.shipRatesChecked = true;
    },
    setCartTotals: function setCartTotals(state, totals) {
      if (totals.shipping) {
        state.cart.totals.shipping = totals.shipping;
      }
      if (totals.discounts) {
        state.cart.totals.discounts = totals.discounts;
      }
    },
    setCartExtraProductInfo: function setCartExtraProductInfo(state, cartExtraProductInfo) {
      state.cart.extraProductInfo = cartExtraProductInfo;
    },
    setDiscountsLoaded: function setDiscountsLoaded(state, status) {
      state.cart.discountsLoaded = status;
    },
    setDiscountsApplying: function setDiscountsApplying(state, status) {
      state.cart.discountsApplying = status;
    },
    setDiscounts: function setDiscounts(state, discounts) {
      state.cart.discounts = discounts;
    },
    setCartGiftNoteVariantId: function setCartGiftNoteVariantId(state, giftNoteVariantId) {
      state.cart.giftNoteVariantId = giftNoteVariantId;
    },
    setCartGiftNoteTo: function setCartGiftNoteTo(state, giftNoteTo) {
      state.cart.giftNote.to = giftNoteTo;
    },
    setCartGiftNoteFrom: function setCartGiftNoteFrom(state, giftNoteFrom) {
      state.cart.giftNote.from = giftNoteFrom;
    },
    setCartGiftNoteMessage: function setCartGiftNoteMessage(state, giftNoteMessage) {
      state.cart.giftNote.message = giftNoteMessage;
    },
    resetGiftNote: function resetGiftNote(state) {
      state.cart.giftNote = {
        to: '',
        from: '',
        message: '',
        editMode: true,
        hasNote: false
      };
    },
    setCartGiftNoteEditMode: function setCartGiftNoteEditMode(state, editMode) {
      state.cart.giftNote.editMode = editMode;
    },
    setCartGiftNoteHasNote: function setCartGiftNoteHasNote(state, hasNote) {
      state.cart.giftNote.hasNote = hasNote;
    },
    increaseCheckRatesMadeTries: function increaseCheckRatesMadeTries(state) {
      state.cart.checkRatesMadeTries++;
    },
    setDrawerVisible: function setDrawerVisible(state, drawerVisible) {
      state.cart.drawerVisible = drawerVisible;
    },
    setAutoCloseDrawer: function setAutoCloseDrawer(state, autoClose) {
      state.cart.autoCloseDrawer = autoClose;
    },
    setCantEstimateShipping: function setCantEstimateShipping(state) {
      state.cart.cantEstimateShipping = true;
    },
    setCartBusy: function setCartBusy(state, busy) {
      state.cart.busy = busy;
    },
    setCheckingShippingRates: function setCheckingShippingRates(state, checking) {
      state.cart.checkingShippingRates = checking;
    },
    setBackdropType: function setBackdropType(state, backdropType) {
      state.common.backdropType = backdropType;
    },
    setBackdropVisible: function setBackdropVisible(state, backdropVisible) {
      state.common.backdropVisible = backdropVisible;
    },
    setMenuDrawerVisible: function setMenuDrawerVisible(state, menuDrawerVisible) {
      state.common.menuDrawerVisible = menuDrawerVisible;
    },
    setVisibleProduct: function setVisibleProduct(state, visibleProduct) {
      state.product.visibleProduct = visibleProduct;
    },
    addLoadedProductImages: function addLoadedProductImages(state, handle) {
      state.collection.loadedProductImages.push(handle);
    },
    addProductToIndex: function addProductToIndex(state, product) {
      if (!state.common.productIndex[product.handle]) {
        state.common.productIndex[product.handle] = product;
      }
    },
    addProductReferenceToHandle: function addProductReferenceToHandle(state, product) {
      if (!state.common.productReferenceToHandle[product.reference]) {
        state.common.productReferenceToHandle[product.reference] = product.handle;
      }
    },
    increaseAllProductsLoadedPage: function increaseAllProductsLoadedPage(state) {
      state.common.allProductsLoadedPage++;
    },
    setAllProductsLoaded: function setAllProductsLoaded(state) {
      state.common.allProductsLoaded = true;
    },
    destroyNotification: function destroyNotification(state) {
      state.notification = {
        link: {
          href: '',
          text: ''
        },
        message: '',
        type: '',
        autoDestroy: true
      };
    },
    setNotification: function setNotification(state, notification) {
      state.notification = notification;
    },
    setCookiesBannerVisible: function setCookiesBannerVisible(state, visible) {
      state.cookiesBanner.bannerVisible = visible;
    }
  },

  actions: {
    loadCart: function loadCart(_ref) {
      var _this = this;

      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      var loadDiscounts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var cart;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch('/cart.js').then(function (response) {
                  return response.json();
                }).then(function () {
                  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
                    var original, formattedCart;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:

                            /*
                              Shallow clone the response as we are gonna
                              modify the cart and we also need the original
                            */
                            original = Object.assign({}, response);
                            // Format the cart (group packs)

                            _context.next = 3;
                            return dispatch('formatCart', response);

                          case 3:
                            formattedCart = _context.sent;

                            commit('changeCart', formattedCart);

                            if (loadDiscounts) {
                              dispatch('loadDiscounts');
                            }

                            // Return the original cart
                            return _context.abrupt('return', original);

                          case 7:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  // this.loader.hide();
                  console.error(error);
                });

              case 2:
                cart = _context2.sent;
                return _context2.abrupt('return', cart);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },


    // eslint-disable-next-line no-unused-vars
    formatCart: function formatCart(_ref3, cartResponse) {
      var state = _ref3.state;


      if (!cartResponse.items.length) {
        return cartResponse;
      }

      var items = [];
      var itemCount = 0;
      var packIndex = {};

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = cartResponse.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (state.cart.extraProductInfo.hasOwnProperty(item.product_id)) {
            for (var fieldSlug in state.cart.extraProductInfo[item.product_id]) {
              if (Object.hasOwnProperty.call(state.cart.extraProductInfo[item.product_id], fieldSlug) && state.cart.extraProductInfo[item.product_id][fieldSlug]) {
                item[fieldSlug] = state.cart.extraProductInfo[item.product_id][fieldSlug];
              }
            }
          }

          if (!item.properties || !item.properties._packId || !item.properties._packItemType) {
            item.itemType = 'simple';
            items.push(item);
            itemCount += item.quantity;
          } else {
            var packId = item.properties._packId;
            if (packIndex.hasOwnProperty(packId)) {
              var packItemIndex = packIndex[packId];
              if (item.properties._packItemType === 'child') {
                items[packItemIndex].childs.push(item);
                items[packItemIndex].packPrice += item.final_price;
                items[packItemIndex].packOriginalPrice += item.price;
              } else {
                if (items[packItemIndex][item.properties._packItemType]) {
                  console.error(item.properties._packItemType + ' already exists for pack ' + item.properties._packId);
                  // todo - eliminamos el item?
                  continue;
                }
                if (item.properties._packItemType === 'parent') {
                  item.packType = item.properties._packType;
                }
                items[packItemIndex][item.properties._packItemType] = item;
              }
            } else {
              itemCount += item.quantity;
              packIndex[packId] = items.length;
              var pack = {
                itemType: 'pack',
                packPrice: 0,
                packOriginalPrice: 0,
                parent: null,
                packaging: null,
                childs: []
              };

              pack.packSize = item.properties._packSize;
              pack.packId = item.properties._packId;

              if (item.properties._packItemType === 'child') {
                pack.childs.push(item);
                pack.packPrice += item.final_price;
                pack.packOriginalPrice += item.price;
              } else {
                if (item.properties._packItemType === 'parent') {
                  item.packType = item.properties._packType;
                }
                pack[item.properties._packItemType] = item;
              }
              items.push(pack);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var cart = cartResponse;
      // eslint-disable-next-line camelcase
      cart.item_count = itemCount;
      cart.items = items;

      return cart;
    },
    loadDiscounts: function loadDiscounts(_ref4) {
      var _this2 = this;

      var dispatch = _ref4.dispatch,
          commit = _ref4.commit;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var checkoutUrl, checkoutResponse, discountObject, discounts;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (window.theme.cartCouponsEnable) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                checkoutUrl = window.location.origin + '/checkout?t=' + Date.now();
                _context3.next = 5;
                return dispatch('fetchCheckoutDiscounts', checkoutUrl);

              case 5:
                checkoutResponse = _context3.sent;
                discountObject = checkoutResponse.discountObject;

                commit('setDiscountsLoaded', true);
                commit('setDiscounts', discountObject);

                discounts = discountObject && discountObject.discounts_amount ? discountObject.discounts_amount : 0;

                commit('setCartTotals', { discounts: discounts });

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    applyDiscount: function applyDiscount(_ref5, newCouponCode) {
      var _this3 = this;

      var dispatch = _ref5.dispatch,
          commit = _ref5.commit,
          state = _ref5.state;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, appliedDiscount, discountApplyUrl, checkoutResponse, discountObject, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _appliedDiscount, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _appliedDiscount2, discounts;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit('setDiscountsApplying', true);

                if (!(state.cart.discounts && state.cart.discounts.discount_applications)) {
                  _context4.next = 30;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 5;
                _iterator2 = state.cart.discounts.discount_applications[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 16;
                  break;
                }

                appliedDiscount = _step2.value;

                if (!(appliedDiscount.title.toUpperCase() == newCouponCode.toUpperCase())) {
                  _context4.next = 13;
                  break;
                }

                commit('setDiscountsLoaded', true);
                commit('setDiscountsApplying', false);
                return _context4.abrupt('return', {
                  status: 'error',
                  type: 'already_applied'
                });

              case 13:
                _iteratorNormalCompletion2 = true;
                _context4.next = 7;
                break;

              case 16:
                _context4.next = 22;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4['catch'](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 22:
                _context4.prev = 22;
                _context4.prev = 23;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 25:
                _context4.prev = 25;

                if (!_didIteratorError2) {
                  _context4.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context4.finish(25);

              case 29:
                return _context4.finish(22);

              case 30:
                discountApplyUrl = window.location.origin + '/checkout?discount=' + newCouponCode + '&t=' + Date.now();
                _context4.next = 33;
                return dispatch('fetchCheckoutDiscounts', discountApplyUrl);

              case 33:
                checkoutResponse = _context4.sent;
                discountObject = checkoutResponse.discountObject;

                if (!(state.cart.discounts && state.cart.discounts.discount_applications)) {
                  _context4.next = 64;
                  break;
                }

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context4.prev = 39;
                _iterator3 = state.cart.discounts.discount_applications[Symbol.iterator]();

              case 41:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context4.next = 50;
                  break;
                }

                _appliedDiscount = _step3.value;

                if (!(_appliedDiscount.title.toUpperCase() == newCouponCode.toUpperCase())) {
                  _context4.next = 47;
                  break;
                }

                commit('setDiscountsLoaded', true);
                commit('setDiscountsApplying', false);
                return _context4.abrupt('return', {
                  status: 'error',
                  type: 'already_applied'
                });

              case 47:
                _iteratorNormalCompletion3 = true;
                _context4.next = 41;
                break;

              case 50:
                _context4.next = 56;
                break;

              case 52:
                _context4.prev = 52;
                _context4.t1 = _context4['catch'](39);
                _didIteratorError3 = true;
                _iteratorError3 = _context4.t1;

              case 56:
                _context4.prev = 56;
                _context4.prev = 57;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 59:
                _context4.prev = 59;

                if (!_didIteratorError3) {
                  _context4.next = 62;
                  break;
                }

                throw _iteratorError3;

              case 62:
                return _context4.finish(59);

              case 63:
                return _context4.finish(56);

              case 64:
                if (!(Object.keys(discountObject).length === 0)) {
                  _context4.next = 68;
                  break;
                }

                commit('setDiscountsLoaded', true);
                commit('setDiscountsApplying', false);
                return _context4.abrupt('return', {
                  status: 'error',
                  type: 'cart_coupons_wont_work'
                });

              case 68:
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context4.prev = 71;
                _iterator4 = discountObject.discount_applications[Symbol.iterator]();

              case 73:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context4.next = 87;
                  break;
                }

                _appliedDiscount2 = _step4.value;

                if (!(_appliedDiscount2.title.toUpperCase() == newCouponCode.toUpperCase())) {
                  _context4.next = 84;
                  break;
                }

                commit('setDiscountsLoaded', true);
                commit('setDiscountsApplying', false);
                commit('setDiscounts', discountObject);

                discounts = discountObject && discountObject.discounts_amount ? discountObject.discounts_amount : 0;

                commit('setCartTotals', { discounts: discounts });

                if (!(_appliedDiscount2.total_allocated_amount === 0)) {
                  _context4.next = 83;
                  break;
                }

                return _context4.abrupt('return', {
                  status: 'warning',
                  message: checkoutResponse.warning
                });

              case 83:
                return _context4.abrupt('return', {
                  status: 'success'
                });

              case 84:
                _iteratorNormalCompletion4 = true;
                _context4.next = 73;
                break;

              case 87:
                _context4.next = 93;
                break;

              case 89:
                _context4.prev = 89;
                _context4.t2 = _context4['catch'](71);
                _didIteratorError4 = true;
                _iteratorError4 = _context4.t2;

              case 93:
                _context4.prev = 93;
                _context4.prev = 94;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 96:
                _context4.prev = 96;

                if (!_didIteratorError4) {
                  _context4.next = 99;
                  break;
                }

                throw _iteratorError4;

              case 99:
                return _context4.finish(96);

              case 100:
                return _context4.finish(93);

              case 101:

                commit('setDiscountsLoaded', true);
                commit('setDiscountsApplying', false);
                return _context4.abrupt('return', {
                  status: 'error',
                  type: 'invalid_coupon'
                });

              case 104:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[5, 18, 22, 30], [23,, 25, 29], [39, 52, 56, 64], [57,, 59, 63], [71, 89, 93, 101], [94,, 96, 100]]);
      }))();
    },
    fetchCheckoutDiscounts: function fetchCheckoutDiscounts(_ref6, url) {
      var _this4 = this;

      var dispatch = _ref6.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
        var response;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetch(url).then(function (response) {
                  return response.text();
                }).then(function () {
                  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(data) {
                    var checkoutContainer, httpEquivRefresh, discountObject, response, warning;
                    return _regenerator2.default.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            checkoutContainer = document.createElement('div');

                            checkoutContainer.innerHTML = data;

                            httpEquivRefresh = checkoutContainer.querySelector('meta[http-equiv="refresh"]');

                            if (!httpEquivRefresh) {
                              _context5.next = 5;
                              break;
                            }

                            return _context5.abrupt('return', {});

                          case 5:
                            discountObject = checkoutContainer.querySelector('#checkout-discounts-object');

                            if (discountObject) {
                              _context5.next = 8;
                              break;
                            }

                            return _context5.abrupt('return', {});

                          case 8:
                            response = {
                              discountObject: JSON.parse(discountObject.textContent)
                            };
                            warning = checkoutContainer.querySelector('#order-summary [data-reduction-form="update"] .edit_checkout [role="status"].notice--warning .notice__text');

                            if (warning && warning.innerHTML) {
                              response.warning = warning.innerHTML;
                            }

                            return _context5.abrupt('return', response);

                          case 12:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, this);
                  }));

                  return function (_x3) {
                    return _ref7.apply(this, arguments);
                  };
                }());

              case 2:
                response = _context6.sent;
                return _context6.abrupt('return', response);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    addToCart: function addToCart(_ref8, params) {
      var _this5 = this;

      var dispatch = _ref8.dispatch,
          commit = _ref8.commit,
          state = _ref8.state;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8() {
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commit('setCartBusy', true);

                _context8.next = 3;
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                  },
                  body: params.data
                }).then(function (response) {
                  return dispatch('handleErrors', response);
                }).then(function (response) {
                  return response.json();
                }).then(function () {
                  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(response) {
                    var items, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, item, GA4Event;

                    return _regenerator2.default.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:

                            /*
                            if (state.cart.extraProductInfo.hasOwnProperty(item.product_id)) {
                              for (const fieldSlug in state.cart.extraProductInfo[item.product_id]) {
                                if (Object.hasOwnProperty.call(state.cart.extraProductInfo[item.product_id], fieldSlug) 
                                    && state.cart.extraProductInfo[item.product_id][fieldSlug]) {
                                  item[fieldSlug] = state.cart.extraProductInfo[item.product_id][fieldSlug];
                                }
                              }
                            }
                            */

                            items = response.items && Array.isArray(response.items) ? response.items : [response];
                            _iteratorNormalCompletion5 = true;
                            _didIteratorError5 = false;
                            _iteratorError5 = undefined;
                            _context7.prev = 4;


                            for (_iterator5 = items[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                              item = _step5.value;

                              // At compare_at_price to cart item if available
                              if (item.hasOwnProperty('handle') && state.common.productIndex.hasOwnProperty(item.handle)) {
                                state.cart.extraProductInfo[item.product_id] = {};
                                if (state.common.productIndex[item.handle].compare_at_price) {
                                  state.cart.extraProductInfo[item.product_id].compare_at_price = state.common.productIndex[item.handle].compare_at_price;
                                  item.compare_at_price = state.common.productIndex[item.handle].compare_at_price;
                                }
                                if (state.common.productIndex[item.handle].main_category && state.common.productIndex[item.handle].main_category.length) {
                                  state.cart.extraProductInfo[item.product_id].main_category = state.common.productIndex[item.handle].main_category[0];
                                  item.main_category = state.common.productIndex[item.handle].main_category[0];
                                }
                                if (state.common.productIndex[item.handle].length && state.common.productIndex[item.handle].length.length) {
                                  state.cart.extraProductInfo[item.product_id].length = state.common.productIndex[item.handle].length[0];
                                  item.length = state.common.productIndex[item.handle].length[0];
                                }
                                if (state.common.productIndex[item.handle].style && state.common.productIndex[item.handle].style.length) {
                                  state.cart.extraProductInfo[item.product_id].style = state.common.productIndex[item.handle].style[0];
                                  item.style = state.common.productIndex[item.handle].style[0];
                                }
                                if (state.common.productIndex[item.handle].limited_edition && state.common.productIndex[item.handle].limited_edition.length) {
                                  state.cart.extraProductInfo[item.product_id].limited_edition = state.common.productIndex[item.handle].limited_edition[0];
                                  item.limited_edition = state.common.productIndex[item.handle].limited_edition[0];
                                }
                              }
                            }

                            _context7.next = 12;
                            break;

                          case 8:
                            _context7.prev = 8;
                            _context7.t0 = _context7['catch'](4);
                            _didIteratorError5 = true;
                            _iteratorError5 = _context7.t0;

                          case 12:
                            _context7.prev = 12;
                            _context7.prev = 13;

                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                              _iterator5.return();
                            }

                          case 15:
                            _context7.prev = 15;

                            if (!_didIteratorError5) {
                              _context7.next = 18;
                              break;
                            }

                            throw _iteratorError5;

                          case 18:
                            return _context7.finish(15);

                          case 19:
                            return _context7.finish(12);

                          case 20:
                            _context7.next = 22;
                            return dispatch('loadCart');

                          case 22:
                            commit('setCartBusy', false);
                            if (state.cart.shipRatesPrepared) {
                              dispatch('checkShippingRates');
                            } else {
                              dispatch('prepareShippingRates');
                            }

                            if (params.afterActions !== false) {
                              dispatch('postAddToCartActions');
                            }

                            // const items = response.items && Array.isArray(response.items) ? response.items : [response];
                            GA4Event = new CustomEvent('theme:ga4-event', {
                              detail: {
                                items: items,
                                eventType: 'add_to_cart',
                                itemType: 'lineItem'
                              }
                            });

                            document.dispatchEvent(GA4Event);

                          case 27:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this5, [[4, 8, 12, 20], [13,, 15, 19]]);
                  }));

                  return function (_x4) {
                    return _ref9.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  return console.error(error);
                });

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this5);
      }))();
    },
    postAddToCartActions: function postAddToCartActions(_ref10) {
      var commit = _ref10.commit,
          state = _ref10.state;

      if ((0, _getDevice2.default)() === 'desktop') {
        commit('setDrawerVisible', true);
        commit('setAutoCloseDrawer', true);
        setTimeout(function () {
          if (state.cart.autoCloseDrawer) {
            commit('setDrawerVisible', false);
          }
        }, 4000);
      } else {
        commit('setNotification', {
          link: {
            href: window.theme.routes.cart,
            text: window.theme.strings.cart.view_cart
          },
          message: window.theme.strings.cart.add_to_cart_success,
          type: 'success',
          autoDestroy: true
        });
      }
    },
    updateCart: function updateCart(_ref11, updateData) {
      var _this6 = this;

      var dispatch = _ref11.dispatch,
          commit = _ref11.commit,
          state = _ref11.state;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10() {
        var response, matchKeys, index, itemToUpdate, data;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                commit('setCartBusy', true);

                commit('setDiscountsLoaded', false);

                _context10.next = 4;
                return dispatch('loadCart', false);

              case 4:
                response = _context10.sent;

                // eslint-disable-next-line func-style
                matchKeys = function matchKeys(item) {
                  return item.key === updateData.id;
                };

                index = response.items.findIndex(matchKeys);
                itemToUpdate = response.items.filter(matchKeys)[0];
                data = {
                  line: '' + (index + 1),
                  quantity: updateData.quantity
                };
                return _context10.abrupt('return', fetch('/cart/change.js', {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(data)
                }).then(function (changeResponse) {
                  return dispatch('handleErrors', changeResponse);
                }).then(function (changeResponse) {
                  return changeResponse.json();
                }).then(function () {
                  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(changeResponse) {
                    var formattedCart, eventType, items, index, GA4Event;
                    return _regenerator2.default.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return dispatch('formatCart', changeResponse);

                          case 2:
                            formattedCart = _context9.sent;

                            commit('changeCart', formattedCart);

                            commit('setCartBusy', false);

                            dispatch('loadDiscounts');

                            if (state.cart.shipRatesPrepared) {
                              dispatch('checkShippingRates');
                            } else {
                              dispatch('prepareShippingRates');
                            }

                            // If product is the GiftNote product, then remove also the giftNote attributes
                            if (updateData.id.split(':')[0] == state.cart.giftNoteVariantId) {
                              dispatch('removeGiftNoteAttributes');
                            }

                            eventType = void 0;
                            items = void 0;
                            index = changeResponse.items.findIndex(matchKeys);

                            if (changeResponse.items[index]) {
                              eventType = changeResponse.items[index].quantity - itemToUpdate.quantity > 0 ? 'add_to_cart' : 'remove_from_cart';
                              items = [Object.assign({}, changeResponse.items[index])];
                              items[0].quantity = 1;
                            } else {
                              eventType = 'remove_from_cart';
                              items = [Object.assign({}, itemToUpdate)];
                              items[0].quantity = 1;
                            }

                            GA4Event = new CustomEvent('theme:ga4-event', {
                              detail: {
                                items: items,
                                eventType: eventType,
                                itemType: 'lineItem'
                              }
                            });

                            document.dispatchEvent(GA4Event);

                          case 14:
                          case 'end':
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this6);
                  }));

                  return function (_x5) {
                    return _ref12.apply(this, arguments);
                  };
                }()));

              case 10:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this6);
      }))();
    },


    // eslint-disable-next-line no-unused-vars
    handleErrors: function handleErrors(_ref13, response) {
      var commit = _ref13.commit;

      if (!response.ok) {
        return response.json().then(function (json) {
          commit('setNotification', {
            message: json.description,
            type: 'error',
            autoDestroy: true
          });
          commit('setCartBusy', false);
          var error = new _fetchError2.default({
            status: response.statusText,
            headers: response.headers,
            json: json
          });
          throw error;
        });
      }
      return response;
    },
    addPackToCart: function addPackToCart(_ref14) {
      var _this7 = this;

      var commit = _ref14.commit,
          dispatch = _ref14.dispatch,
          state = _ref14.state;
      var packTipology = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'packs';
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11() {
        var _packId, items, _packSize, itemIndex, _packType, _packagingImg, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, product, cartPayload, params;

        return _regenerator2.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _packId = Date.now();
                items = [];
                _packSize = state[packTipology].packCount ? state[packTipology].packCount : state[packTipology].packProducts.length;
                itemIndex = _packSize + 2;
                _packType = packTipology == 'familyPack' ? 'family-pack' : state[packTipology].packType;
                _packagingImg = state[packTipology].packConfig.packagingImg ? state[packTipology].packConfig.packagingImg : '';
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context11.prev = 9;


                for (_iterator6 = state[packTipology].packProducts[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  product = _step6.value;

                  items.push({
                    quantity: 1,
                    id: product.variantId,
                    properties: {
                      _packSize: _packSize,
                      _packItemType: 'child',
                      _packItemId: _packId + '-' + itemIndex,
                      _packId: _packId,
                      _packType: _packType
                    }
                  });
                  itemIndex--;
                }

                _context11.next = 17;
                break;

              case 13:
                _context11.prev = 13;
                _context11.t0 = _context11['catch'](9);
                _didIteratorError6 = true;
                _iteratorError6 = _context11.t0;

              case 17:
                _context11.prev = 17;
                _context11.prev = 18;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 20:
                _context11.prev = 20;

                if (!_didIteratorError6) {
                  _context11.next = 23;
                  break;
                }

                throw _iteratorError6;

              case 23:
                return _context11.finish(20);

              case 24:
                return _context11.finish(17);

              case 25:
                items.push({
                  quantity: 1,
                  id: state[packTipology].packConfig.packaging,
                  properties: {
                    _packSize: _packSize,
                    _packItemType: 'packaging',
                    _packItemId: _packId + '-2',
                    _packId: _packId,
                    _packType: _packType
                  }
                });

                items.push({
                  quantity: 1,
                  id: state[packTipology].packConfig.parent,
                  properties: {
                    _packSize: _packSize,
                    _packItemType: 'parent',
                    _packItemId: _packId + '-1',
                    _packType: _packType,
                    _packId: _packId,
                    _packagingImg: _packagingImg
                  }
                });

                cartPayload = {
                  items: items
                };
                params = { data: JSON.stringify(cartPayload) };
                _context11.next = 31;
                return dispatch('addToCart', params);

              case 31:
                if (packTipology == 'packs') {
                  commit('changePackProducts', []);
                } else {
                  commit('changeFamilyPackProducts', []);
                  setTimeout(function () {
                    return commit('setFamilyPackConfiguratorOpen', false);
                  }, 500);
                }

              case 32:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this7, [[9, 13, 17, 25], [18,, 20, 24]]);
      }))();
    },
    removePack: function removePack(_ref15, packId) {
      var _this8 = this;

      var dispatch = _ref15.dispatch,
          commit = _ref15.commit;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
        var matchKeys, response, index, changeResponse, data, formattedCart;
        return _regenerator2.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:

                commit('setCartBusy', true);

                commit('setDiscountsLoaded', false);

                // eslint-disable-next-line func-style

                matchKeys = function matchKeys(item) {
                  return item.properties && item.properties._packId && item.properties._packId === packId;
                };

                _context12.next = 5;
                return dispatch('loadCart', false);

              case 5:
                response = _context12.sent;
                index = response.items.findIndex(matchKeys);
                changeResponse = void 0;

              case 8:
                if (!(index !== -1)) {
                  _context12.next = 19;
                  break;
                }

                data = {
                  line: '' + (index + 1),
                  quantity: 0
                };
                _context12.next = 12;
                return fetch('/cart/change.js', {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(data)
                });

              case 12:
                changeResponse = _context12.sent;
                _context12.next = 15;
                return changeResponse.json();

              case 15:
                changeResponse = _context12.sent;

                index = changeResponse.items.findIndex(matchKeys);
                _context12.next = 8;
                break;

              case 19:
                _context12.next = 21;
                return dispatch('formatCart', changeResponse);

              case 21:
                formattedCart = _context12.sent;

                commit('changeCart', formattedCart);

                commit('setCartBusy', false);

                dispatch('loadDiscounts');

                dispatch('checkShippingRates');

              case 26:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this8);
      }))();
    },
    prepareShippingRates: function prepareShippingRates(_ref16) {
      var state = _ref16.state,
          commit = _ref16.commit,
          dispatch = _ref16.dispatch;

      var shipping = JSON.stringify(state.cart.estimateAddress);
      var hasErrors = false;
      fetch('/cart/prepare_shipping_rates.json', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        },
        body: shipping
      }).then(function (response) {
        if (response.status > 202) {
          hasErrors = true;
        }
        return response.json();
      }).then(function (response) {
        if (hasErrors) {
          commit('setCantEstimateShipping');
          console.error(response);
          return false;
        } else {
          commit('setShipRatesPrepared');
          dispatch('checkShippingRates');
        }
      }).catch(function (error) {
        return console.error(error);
      });
    },
    checkShippingRates: function checkShippingRates(_ref17) {
      var state = _ref17.state,
          commit = _ref17.commit,
          dispatch = _ref17.dispatch;

      commit('setCheckingShippingRates', true);
      if (state.cart.checkRatesMadeTries > state.cart.checkRatesMaxTries) {
        commit('setCantEstimateShipping');
        console.error('Error: Max tries to fetch shipping rates reached.');
        commit('setCheckingShippingRates', false);
        return false;
      }
      fetch('/cart/async_shipping_rates.json').then(function (response) {
        return response.json();
      }).then(function (response) {

        if (response && response.shipping_rates && response.shipping_rates.length) {

          var shipping = parseInt(response.shipping_rates[0].price * 100, 10);
          commit('setCartTotals', { shipping: shipping });
          commit('setShipRatesChecked');

          var deliveryEstimates = state.cart.estimatedDelivery.getDeliveryEstimates(response.shipping_rates);
          commit('changeEstimates', deliveryEstimates);
          commit('setCheckingShippingRates', false);
        } else {
          commit('increaseCheckRatesMadeTries');
          setTimeout(function () {
            dispatch('checkShippingRates');
          }, 100);
        }
      }).catch(function (error) {
        commit('increaseCheckRatesMadeTries');
        setTimeout(function () {
          dispatch('checkShippingRates');
        }, 100);
        console.error(error);
      });

      return false;
    },
    setCartAttributes: function setCartAttributes(_ref18, attributes) {
      var _this9 = this;

      var dispatch = _ref18.dispatch,
          commit = _ref18.commit;

      return fetch('/cart/update.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: attributes
        })
      }).then(function (changeResponse) {
        return dispatch('handleErrors', changeResponse);
      }).then(function (changeResponse) {
        return changeResponse.json();
      }).then(function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(changeResponse) {
          var formattedCart;
          return _regenerator2.default.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.next = 2;
                  return dispatch('formatCart', changeResponse);

                case 2:
                  formattedCart = _context13.sent;

                  commit('changeCart', formattedCart);
                  commit('setCartBusy', false);
                  dispatch('checkShippingRates');

                case 6:
                case 'end':
                  return _context13.stop();
              }
            }
          }, _callee13, _this9);
        }));

        return function (_x7) {
          return _ref19.apply(this, arguments);
        };
      }());
    },
    addGiftNote: function addGiftNote(_ref20, productId) {
      var _this10 = this;

      var dispatch = _ref20.dispatch;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14() {
        var items, itemId, cartPayload, data, params;
        return _regenerator2.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                items = [];
                itemId = productId;


                items.push({
                  quantity: 1,
                  id: itemId
                });

                cartPayload = {
                  items: items
                };
                data = JSON.stringify(cartPayload);
                params = {
                  data: data,
                  afterActions: false
                };
                _context14.next = 8;
                return dispatch('addToCart', params);

              case 8:
                return _context14.abrupt('return', false);

              case 9:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this10);
      }))();
    },
    removeGiftNoteAttributes: function removeGiftNoteAttributes(_ref21) {
      var commit = _ref21.commit,
          dispatch = _ref21.dispatch;

      commit('resetGiftNote');
      var removeAttr = {
        'gift-from': '',
        'gift-to': '',
        'gift-note': ''
      };
      dispatch('setCartAttributes', removeAttr);
    },
    removeGiftNoteProduct: function removeGiftNoteProduct(_ref22, productId) {
      var _this11 = this;

      var dispatch = _ref22.dispatch,
          commit = _ref22.commit;
      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16() {
        var itemId, data;
        return _regenerator2.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                itemId = productId;


                commit('setCartBusy', true);

                commit('setDiscountsLoaded', false);

                _context16.next = 5;
                return dispatch('loadCart', false);

              case 5:
                data = {
                  quantity: 0,
                  id: itemId
                };
                _context16.next = 8;
                return fetch('/cart/change.js', {
                  method: 'post',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(data)
                }).then(function (changeResponse) {
                  return dispatch('handleErrors', changeResponse);
                }).then(function (changeResponse) {
                  return changeResponse.json();
                }).then(function () {
                  var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(changeResponse) {
                    var formattedCart;
                    return _regenerator2.default.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            _context15.next = 2;
                            return dispatch('formatCart', changeResponse);

                          case 2:
                            formattedCart = _context15.sent;


                            commit('changeCart', formattedCart);

                            commit('setCartBusy', false);

                            dispatch('loadDiscounts');

                            dispatch('checkShippingRates');

                          case 7:
                          case 'end':
                            return _context15.stop();
                        }
                      }
                    }, _callee15, _this11);
                  }));

                  return function (_x8) {
                    return _ref23.apply(this, arguments);
                  };
                }());

              case 8:
                return _context16.abrupt('return', _context16.sent);

              case 9:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this11);
      }))();
    }
  }
});